import { Button } from 'react-bootstrap';
import { Dialog, DialogContent } from '@mui/material';
import React from 'react';


interface Props {
  isOpen: boolean;
  handleNext: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function DialogConfirmarForm({ isOpen, handleNext, setIsOpen }: Props) {
  return (
    <>
      {isOpen && (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
          <DialogContent className="flex flex-col gap-2 justify-center items-center">
            <h4 className="mb-4">¿Los datos que ingresaste son correctos?</h4>
            <div className="flex items-center justify-center gap-4">
              <Button
                onClick={handleNext}
                variant="contained"
                className="p-2 px-4 rounded-lg"
                style={{ backgroundColor: '#FF8E01', color: 'white' }}
              >
                Sí
              </Button>
              <Button
                onClick={() => setIsOpen(false)}
                variant="contained"
                className="bg-black p-2 px-4 rounded-lg text-white"
              >
                No
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default DialogConfirmarForm;
